const en = {
  login: {
    jeema: "Jeema",
    login: "Login",
    forget_password: "Forget Password?",
    email: "Username",
    password: "Password",
    email_warning: "Username is required",
    password_warning: "Password is required",
  },
  toastify: {
    login_success: "Login Successful",
    invalid_message: "Invalid username or password",
  },
  header: {
    dashboard: "Dashboard",
    profile: "Profile",
    logout: "Logout",
  },
  profile: {
    settings: "Settings",
    dashboard: "Dashboard",
    personalInformation: "Personal Information",
    firstName: "Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    updatePassword: "Update Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    cancel: "Cancel",
    save: "Save",
  },
  sidebar: {
    jeema: "Jeema",
    dashboard: "Dashboard",
    appManagement: "App Management",
    salons: "Salons",
    salonRequests: "Salon Requests",
    users: "Users",
    services: "Services",
    serviceList: "Service List",
    bookings: "Bookings",
    payments: "Payments",
    customerSupport: "Customer Support",
    tickets: "Tickets",
    queries: "Queries",
    reports: "Reports",
    coupons: "Coupons",
    charges: "Charges",
    customersupport: "Customer & Support",
    faqs: "FAQ's",
    weeklyOffers: "Weekly Offers",
    supportOffers: "Support & Offers",
  },
  dashboard: {
    dashboard: "Dashboard",
    systemOverview: "System Overview",
    totalBookings: "Total Bookings",
    totalEarnings: "Total Earnings",
    totalCustomers: "Total Customers",
    salons: "Salons",
    earnings: "Earnings",
    allPayments: "All Payments",
    earningOverTime: "Earning over Time",
    thisYear: "This Year",
    totalBusiness: "Total Business",
    individual: "Individual",
    commercial: "Commercial",
  },
  salon: {
    salonsList: "Salons List",
    salonsListManagement: "Salons List Management",
    noData: "No data found",
    dashboard: "Dashboard",
    salons: "Salons",
    filter: "Filter By status",
    all: "All",
    busy: "Busy",
    offline: "Offline",
    blocked: "Blocked",
    available: "Available",
    businessName: "Business Name",
    businessType: "Business Type",
    individual: "Individual",
    commercial: "Commercial",
    teamSize: "Team Size",
    genderService: "Gender Service",
    commercialId: "Commercial ID",
    phoneNumber: "Phone Number",
    contactAt: "Contact At",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    cancel: "Cancel",
    salon: "Salon",
    block: "Block",
    unblock: "Unblock",
    warning: "Are you sure you want to",
  },
  salon_request: {
    salonRequests: "Salon Requests",
    salonRequestManagement: "Salon Request Management",
    dashboard: "Dashboard",
    salonRequestList: "Salon Request List",
    filter: "Filter By status",
    all: "All",
    blocked: "Blocked",
    unverfied: "Unverified",
    rejected: "Rejected",
    noData: "No data found",
    businessName: "Business Name",
    businessType: "Business Type",
    individual: "Individual",
    commercial: "Commercial",
    genderService: "Gender Service",
    commercialId: "Commercial ID",
    phoneNumber: "Phone Number",
    contactAt: "Contact At",
    verified: "Verified",
    createdAt: "Created At",
    status: "Status",
    actions: "Actions",
    rejectDocument: "Reject Document",
    enterReason: "Enter Reason",
    documentRejected: "Document Rejected",
    verificationPending: "Document Verification Pending",
    cancel: "Cancel",
    salon: "Salon",
    block: "Block",
    unblock: "Unblock",
    warning: "Are you sure you want to",
    submitRejection: "Submit Rejection",
    page: "Page",
    of: "of",
  },
  salon_verification: {
    documentReview: "Document Review",
    rejected: "Rejected",
    pending: "Pending",
    registrationNumber: "Registration No.",
    status: "Status",
    preview: "Preview",
    actions: "Actions",
    documentPreview: "Document Preview",
    reason: "Reason",
    reject: "Reject",
    accept: "Accept",
  },
  users: {
    users: "Users",
    userManagement: "User Management",
    dashboard: "Dashboard",
    userList: "User List",
    filter: "Filter By status",
    active: "Active",
    blocked: "Blocked",
    all: "All",
    noData: "No data found",
    name: "Name",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    phoneNumber: "Phone Number",
    createdAt: "Created At",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    cancel: "Cancel",
    user: "User",
    block: "Block",
    unblock: "Unblock",
    warning: "Are you sure you want to",
  },
  user_details: {
    userDetails: "User Details",
    userDetailsManagement: "User Details Management",
    dashboard: "Dashboard",
    users: "Users",
    email: "Email",
    phone: "Phone",
    gender: "Gender",
    country: "Country",
    totalBookings: "Total Bookings",
    totalProfit: "Total Profit",
    male: "Male",
    female: "Female",
    other: "Other",
    notAvailable: "Not Available",
  },
  toaster: {
    salonVerified: "Salon Verified Successfully",
    salonRejected: "Salon Rejected Succesfully",
    userBlocked: "User Blocked Successfully",
    userUnblocked: "User Unblocked Successfully",
    salonBlocked: "Salon Blocked Successfully",
    salonUnblocked: "Salon Unblocked Successfully",
    errorOccured: "An error occurred",
    service_deleted_successfully: "Service deleted successfully",
    service_added_successfully: "Service added successfully",
    service_updated_successfully: "Service updated successfully",
    queryrevertedsuccessfully: "Query reverted successfully",
    enterReportmessage: "Enter Report message",
    reportrevertedsuccessfully: "Report reverted successfully",
    ticketrevertedsuccessfully: "Ticket reverted successfully",
    faqAddedSuccessfully: "Faq Added Successfully",
    faqUpdatedSuccessfully: "FAQ Updated Successfully",
    faqdeletedSuccessfully: "Faq deleted Successfully",
    weeklyOfferAddedSuccessfully: "Weekly Offer Added Successfully",
    weeklyOfferUpdatedSuccessfully: "Weekly Offer Updated Successfully",
    weeklyOfferdeletedSuccessfully: "Weekly Offer deleted Successfully",
    weeklyofferpublishedsuccessfully: "Weekly offer published successfully",
    failedtopublishweeklyoffer: "Failed to publish weekly offer",
    coupondeletedSuccessfully: "Coupon deleted Successfully",
    couponupdatedSuccessfully: "Coupon updated Successfully",
    couponaddedSuccessfully: "Coupon added Successfully",
    couponstatusupdatedsuccessfully: "Coupon status updated successfully",
    failedtoupdatecouponstatus: "Failed to update coupon status",
    configdeletedSuccessfully: "Config deleted Successfully",
    configUpdatedsuccessfully: "Config Updated successfully",
    configaddedsuccessfully: "Config added successfully",
    configstatusupdatedsuccessfully: "Config status updated successfully",
    failedtoupdateconfigstatus: "Failed to update config status",
  },
  salon_info: {
    salons: "Salons",
    salonsListManagement: "Salons List Management",
    salonRequest: "Salon Requests",
    salonRequestManagement: "Salon Request Management",
    dashboard: "Dashboard",
    salonDetails: "Salon Details",
    basicDetails: "Basic Details",
    documentDetails: "Document Details",
    salonInfo: "Salon Info",
    businessHours: "Business Hours",
    contactDetails: "Contact Details",
    salonImages: "Salon Images",
    commercialId: "Commercial ID",
    registrationNo: "Registration No",
    registarationVerified: "Registration Verified",
    reason: "Reason",
    teamSize: "Team Size",
    genderService: "Gender Service",
    businessType: "Business Type",
    homeService: "Home Service",
    salonStatus: "Salon Status",
    categories: "Categories",
    noBusiness: "No business hours available.",
    email: "Email",
    address: "Address",
    zipcode: "Zipcode",
    country: "Country",
    phone: "Phone",
    staffMembers: "Staff Members",
    gender: "Gender",
    noImage: "No images available.",
    noStaff: "No staff available.",
    individual: "Individual",
    commercial: "Commercial",
    available: "Available",
    notAvailable: "Not Available",
    closed: "Closed",
    rejected: "Rejected",
    no: "No",
    employee: "Employee ID",
    status: "Status",
    serviceDetails: "Service Details",
  },
  staff: {
    phone: "Phone",
    bio: "Bio",
    gender: "Gender",
    genderService: "Gender Service",
    specialistIn: "Specialist In",
    homeService: "Home Service",
    workingDays: "Working Days",
    workingHours: "Working Hours",
    breakTime: "Break Time",
    services: "Services",
    notAvailable: "Not Available",
    yes: "Yes",
    no: "No",
    employee: "Employee ID",
    address: "Address",
    country: "Country",
    status: "Status",
  },
  booking: {
    bookings: "Bookings",
    bookingManagement: "Booking List Management",
    dashboard: "Dashboard",
    bookingList: "Booking List",
    filter: "Filter By status",
    all: "All",
    completed: "Completed",
    pending: "Pending",
    cancelled: "Cancelled",
    rescheduled: "Rescheduled",
    confirmed: "Confirmed",
    noShow: "No Show",
    noData: "No data found",
    userName: "User Name",
    salonName: "Salon Name",
    staffName: "Staff Name",
    bookingDate: "Booking Date",
    duration: "Duration",
    timing: "Timing",
    userPhone: "User Phone Number",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
  },
  booking_details: {
    bookingDetails: "Booking Details",
    bookingDetailsManagement: "Booking Detail Management",
    dashboard: "Dashboard",
    bookings: "Bookings",
    userDetails: "User Details",
    name: "Name",
    email: "Email",
    phone: "Phone",
    gender: "Gender",
    genderService: "Gender Service",
    notAvailable: "Not Available",
    male: "Male",
    female: "Female",
    other: "Other",
    salonDetails: "Salon Details",
    commercialId: "Commercial ID",
    staffDetails: "Staff Details",
    specialistIn: "Specialist In",
    paymentDetails: "Payment Details",
    paymentType: "Payment Type",
    paymentStatus: "Payment Status",
    promoCode: "Promo Code",
    discountType: "Discount Type",
    totalAmount: "Total Amount",
    date: "Date",
    time: "Time",
    duration: "Duration",
    status: "Status",
    categories: "Service",
  },
  queries: {
    queriesManagement: "Queries Management",
    dashboard: "Dashboard",
    queries: "Queries",
    queryList: "Query List",
    filterBystatus: "Filter By status",
    all: "All",
    pending: "Pending",
    resolved: "Resolved",
    nodata: "No data",
    name: "Name",
    query: "Query",
    createdBy: "Created By",
    createdAt: "Created At",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    confirmDelete: "Confirm Delete",
    warning: "Are you sure you want to delete the query?",
    cancel: "Cancel",
    delete: "Delete",
    queryDetails: "Query Details",
    reportedAt: "Reported At",
    reportedBy: "Reported By",
    description: "Description",
    userDetails: "User Details",
    email: "Email",
    phone: "Phone",
    salonDetails: "Salon Details",
    close: "Close",
    business: "Business",
    country: "Country",
    queryMessage: "Query Message",
    submit: "Submit",
    enterquerymessage: "Enter query message",
  },
  reports: {
    reports: "Reports",
    reportManagement: "Report Management",
    dashboard: "Dashboard",
    reportList: "Report List",
    filterBystatus: "Filter By status",
    all: "All",
    pending: "Pending",
    resolved: "Resolved",
    nodata: "No data",
    reporter: "Reporter",
    reportedUser: "Reported User",
    topic: "Topic",
    reportedAt: "Reported At",
    reportedBy: "Reported By",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    confirmDelete: "Confirm Delete",
    warning: "Are you sure you want to delete Report?",
    cancel: "Cancel",
    delete: "Delete",
    reportDetails: "Report Details",
    homeService: "Home Service",
    reportTitle: "Report Title",
    description: "Description",
    reporterUser: "Reporter (User)",
    reporterSalon: "Reporter (Salon)",
    name: "Name",
    email: "Email",
    phone: "Phone",
    business: "Business",
    staffInvolved: "Staff Involved",
    gender: "Gender",
    servicesInvolved: "Services Involved",
    close: "Close",
    reportMessage: "Report Message",
    submit: "Submit",
    enterReportmessage: "Enter Report message",
  },
  ticket: {
    tickets: "Tickets",
    ticketsManagement: "Tickets Management",
    dashboard: "Dashboard",
    ticketList: "Ticket List",
    filterBystatus: "Filter By status",
    all: "All",
    pending: "Pending",
    resolved: "Resolved",
    nodata: "No data",
    ticketID: "Ticket ID",
    name: "Name",
    topic: "Topic",
    createdBy: "Created By",
    createdAt: "Created At",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    confirmDelete: "Confirm Delete",
    warning: "Are you sure you want to delete Ticket?",
    cancel: "Cancel",
    delete: "Delete",
    ticketDetails: "Ticket Details",
    reportedAt: "Reported At",
    reportedBy: "Reported By",
    description: "Description",
    userDetails: "User Details",
    email: "Email",
    phone: "Phone",
    salonDetails: "Salon Details",
    business: "Business",
    country: "Country",
    bookingDetails: "Booking Details",
    customerInformation: "Customer Information",
    salonInformation: "Salon Information",
    staffMember: "Staff Member",
    bookingDate: "Booking Date",
    close: "Close",
    submit: "Submit",
    enterticketmessage: "Enter ticket message",
  },
  faq: {
    fAQs: "FAQs",
    fAQsManagement: "FAQs Management",
    dashboard: "Dashboard",
    faqsList: "FAQs List",
    addFAQ: "ADD FAQ",
    noData: "No data found",
    page: "Page",
    of: "of",
    question: "Question",
    answer: "Answer",
    actions: "Actions",
    confirmDelete: "Confirm Delete",
    warning: "Are you sure you want to delete FAQs",
    cancel: "Cancel",
    delete: "Delete",
    addNewFaq: "Add New Faq",
    submit: "Submit",
    updateFaq: "Update Faq",
    update: "Update",
  },
  weekly_offer: {
    weeklyOffers: "Weekly Offers",
    weeklyOffersManagement: "Weekly Offers Management",
    dashboard: "Dashboard",
    weeklyOffer: "Weekly Offer",
    weeklyOfferList: "Weekly Offer List",
    addWeeklyOffer: "Add Weekly Offer",
    noData: "No data found",
    offerPic: "Offer Pic",
    title: "Title",
    code: "Code",
    description: "Description",
    status: "Status",
    actions: "Actions",
    confirmDelete: "Confirm Delete",
    warning: "Are you sure you want to delete Weekly Offer?",
    cancel: "Cancel",
    delete: "Delete",
    offerPicture: "Offer Picture",
    selectacoupon: "Select a coupon",
    submit: "Submit",
    updateWeeklyOffer: "Update Weekly Offer",
    update: "Update",
    confirmPublishWeeklyOffer: "Confirm Publish Weekly Offer",
    note: "Note",
    publish: "Publish",
    notPublished: "Not Published",

    Oncepublishedtheweeklyofferwillbevisibletousersandcannotbeedited:
      "Once published, the weekly offer will be visible to users and cannot be edited",
  },
  payment: {
    payments: "Payments",
    paymentsManagement: "Payments Management",
    dashboard: "Dashboard",
    paymentsList: "Payments List",
    filterByStatus: "Filter By Status",
    all: "All",
    paid: "Paid",
    unpaid: "Unpaid",
    noData: "No data found",
    userName: "User Name",
    businessName: "Business Name",
    staffName: "Staff Name",
    paymentMethod: "Payment Method",
    amount: "Amount",
    status: "Status",
    createdAt: "Created At",
    page: "Page",
    of: "of",
  },
  coupons: {
    addCoupon: "Add Coupon",
    dashboard: "Dashboard",
    coupons: "Coupons",
    couponList: "Coupon List",
    filterbyStatus: "Filter by Status",
    all: "All",
    active: "Active",
    inactive: "Inactive",
    expired: "Expired",
    noData: "No data found",
    code: "Code",
    expiredDate: "Expired Date",
    minimumAmount: "Minimum Amount",
    discount: "Discount",
    UsageCountUserLimit: "Usage Count / User Limit",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    confirmDelete: "Confirm Delete",
    warning: "Are you sure you want to delete Coupon",
    cancel: "Cancel",
    delete: "Delete",
    updateDiscountCode: "Update Discount Code",
    discountCode: "Discount Code",
    discountType: "Discount Type",
    select: "Select",
    percentage: "Percentage",
    fixed: "Fixed",
    promoType: "Promo Type",
    oneTime: "One Time",
    multipleUse: "Multiple Use",
    newUser: "New User",
    daily: "Daily",
    weekly: "Weekly",
    validFrom: "Valid From",
    validTo: "Valid To",
    discountValue: "Discount Value",
    maxDiscount: "Max Discount",
    minBillAmount: "Min Bill Amount",
    usageLimit: "Usage Limit",
    userLimit: "User Limit",
    addNewDiscountCode: "Add New Discount Code",
    selectdiscounttype: "Select discount type",
    selectpromotype: "Select promo type",
    confirm_status_change: "Confirm Status Change",
    enterdiscountvalue: "Enter discount value",
    entermaxdiscount: "Enter max discount",
    enterminimumbillamount: "Enter minimum bill amount",
    enterusagelimit: "Enter usage limit",
    enteruserlimit: "Enter user limit",
    adding: "Adding...",
    updating: "Updating...",
    updateCoupon: "Update Coupon",
  },
  charges: {
    charges: "Charges",
    chargesManagement: "Charges Management",
    dashboard: "Dashboard",
    configList: "Config List",
    addConfig: "Add Config",
    name: "Name",
    type: "Type",
    value: "Value",
    description: "Description",
    status: "Status",
    actions: "Actions",
    page: "Page",
    of: "of",
    addNewConfig: "Add New Config",
    configName: "Config Name",
    platformCharge: "Platform Charge",
    vat: "Vat",
    configType: "Config Type",
    percentage: "PERCENTAGE",
    fixed: "FIXED",
    configValue: "Config Value",
    configDescription: "Config Description",
    cancel: "Cancel",
    submit: "Submit",
    updateConfig: "Update Config",
    confirmStatusChange: "Confirm Status Change",
    Warning: "Warning",
    thiswill: "This will",
    deactivate: "deactivate",
    notice: "Notice",
    activate: "activate",
    yes: "Yes",
    no: "No",
    enterdescription: "Enter description",
    active: "Active",
    inactive: "Inactive",
    confirmDelete: "Confirm Delete",
    warning: "Are you sure you want to delete Config",

    update: "Update",
    delete: "Delete",

    theconfigurationItwilltakeeffectandbeusedbythesystemaccordingly:
      "the configuration. It will take effect and be used by the system accordingly.",
    theconfigurationThesystemwillignorethissettinguntilitreactivated:
      "the configuration. The system will ignore this setting until it's reactivated.",
  },
  category: {
    categoryDetails: "Category Details",
    categoryDetailsManagement: "Category Details Management",
    dashboard: "Dashboard",
    categories: "Categories",
    serviceList: "Service List",
    addService: "Add Service",
    update: "Update",
    delete: "Delete",
    addNewService: "Add New Service",
    serviceName: "Service Name",
    serviceDescription: "Service Description",
    servicePicture: "Service Picture",
    cancel: "Cancel",
    submit: "Submit",
    updateService: "Update Service",

    categoriesManagement: "Categories Management",
    categoryList: "Category List",
    addCategory: "Add Category",
    description: "Description",
    categoryPic: "Category Pic",
    categoryName: "Category Name",
    actions: "Actions",
    addNewCategory: "Add New Category",
    categoryDescription: "Category Description",
    categoryPicture: "Category Picture",
    updateCategory: "Update Category",
    descriptionmustbeatleastcharacters:
      "Description must be at least 50 characters.",
  },
  service: {
    services: "Services",
    serviceManagement: "Service List Management",
    dashboard: "Dashboard",
    serviceList: "Service List",
    addService: "Add Service",
    editService: "Update Service",
    addNewService: "Add New Service",
    warning: "Are you sure you want to delete",
    service: "service ?",
    confirmDelete: "Confirm Delete",
    cancel: "Cancel",
    submit: "Submit",
    update: "Update",
    delete: "Delete",
    noData: "No data found",
    serviceName: "Service Name",
    serialNo: "Serial Number",
    createdAt: "Created At",
    actions: "Actions",
    page: "Page",
    of: "of",
  },
  couponStatusModal: {
    confirm_status_change: "Confirm Status Change",
    yes: "Yes",
    no: "No",
    warning: "Warning",
    inactive_warning:
      "Changing the status of this discount code can affect its availability to users. Please review the status change carefully before confirming.",
    active_warning:
      "Are you sure you want to set this discount code to Active? Once active, this discount code will be available for users, and it cannot be reversed without deactivating it. Please double-check the details before confirming the change.",
  },
};

export default en;
